import React from 'react';
import { CONSTANTS } from 'src/components/Constants';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const pillStyles = {
  // Fixed-height inline-flex pill so it never vertically stretches to the row
  // height inside a flex table cell — matches the small MUI Chip used for
  // specialties/tags.
  display: 'inline-flex',
  alignItems: 'center',
  height: 24,
  boxSizing: 'border-box',
  padding: '0 10px',
  borderRadius: '100px',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: 1,
  whiteSpace: 'nowrap'
};

const variants = {
  created: {
    backgroundColor: '#edf0f4',
    color: '#4a5a6a'
  },
  linkCreated: {
    backgroundColor: '#e0f5f8',
    color: '#1a7a8a'
  },
  emailSent: {
    backgroundColor: '#e0f5f8',
    color: '#1a7a8a'
  },
  inProgress: {
    backgroundColor: '#fdf8e0',
    color: '#7a6a0a'
  },
  submitted: {
    backgroundColor: 'var(--color-active-bg)',
    color: 'var(--color-active-fg)'
  },
  imported: {
    backgroundColor: 'var(--color-tag-import-bg)',
    color: 'var(--color-tag-import-fg)'
  },
  merged: {
    backgroundColor: '#efe8ff',
    color: '#5b3cc4'
  },
  deactivated: {
    backgroundColor: 'var(--color-expired-bg)',
    color: 'var(--color-expired-fg)'
  }
};

function StatusPill({ label, variant }) {
  return <span style={{ ...pillStyles, ...variants[variant] }}>{label}</span>;
}

export default function UsersTableStatusCol({ status, merged, mergedInto }) {
  const t = useAutoTranslation();

  if (merged) {
    return (
      <StatusPill
        label={t('Merged into {{mergedInto}}', { mergedInto })}
        variant="merged"
      />
    );
  }

  switch (status) {
    case CONSTANTS.user_status.DEACTIVATED:
      return <StatusPill label={t('Link Deactivated')} variant="deactivated" />;
    case CONSTANTS.user_status.CREATED:
      return <StatusPill label={t('Link Created')} variant="linkCreated" />;
    case CONSTANTS.user_status.PENDING:
      return <StatusPill label={t('E-Mail Sent')} variant="emailSent" />;
    case CONSTANTS.user_status.IN_PROGRESS:
      return <StatusPill label={t('In Progress')} variant="inProgress" />;
    case CONSTANTS.user_status.SUBMITTED:
      return <StatusPill label={t('Submitted')} variant="submitted" />;
    case CONSTANTS.user_status.PEDIGREE_CREATED:
      return <StatusPill label={t('Created')} variant="created" />;
    case CONSTANTS.user_status.IMPORTED:
      return <StatusPill label={t('Imported')} variant="imported" />;
    default:
      return '';
  }
}
